import { FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material'
import { FormFieldSelect } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import { SelectEmpresa, SelectFuncionario } from 'global/components/Selects'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useFuncionariosOutletContext } from 'pages/Funcionarios'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useStore } from 'store'
import { ExportarService as useService } from '../../service/exportar'

const ExportarFuncionario = () => {
    const navigate = useNavigate()
    const toggle = () => navigate('/cadastros/funcionarios')
    const funcionario = useStore(state => state.employee)
    const {
        handleExportarPdf,
        handleExportarXls,
        isCarregando,
        handleExportarCsv,
        handleExportarFicha,
    } = useService()
    const { data: funcionarios } = useFuncionariosOutletContext()
    const [exportarTodos, setExportarTodos] = useState(true)
    const [formato, setFormato] = useState<'pdf' | 'xls' | 'csv'>('xls')

    return (
        <Dialog.Root
            loading={isCarregando}
            onClose={toggle}
            onSubmit={() => {
                if (exportarTodos)
                    switch (formato) {
                        case 'pdf':
                            handleExportarPdf(funcionarios)
                            break
                        case 'xls':
                            handleExportarXls(funcionarios)
                            break
                        default:
                            handleExportarCsv(funcionarios)
                            break
                    }
                else {
                    handleExportarFicha(funcionario!, formato!)
                }
            }}
            open={hasPermission(['read', 'ExportarFuncionários'])}
            width="48rem"
            height="fit-content"
        >
            <Dialog.Title>
                Exportar funcionário
                <IconeAjuda>
                    Os dados incluídos no arquivo são:
                    {[
                        'Matrícula',
                        'Nome',
                        'Cargo/Função',
                        'PIS',
                        'CPF',
                        'Data de admissão',
                    ].map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                    <br />
                    No entanto, é possível exportar apenas a ficha do
                    funcionário, que contém todos os dados cadastrados.
                </IconeAjuda>
            </Dialog.Title>
            <Dialog.Content
                sx={{
                    width: '100%',
                    overflow: 'auto',
                    p: 2,
                }}
                dividers
            >
                <Grid container spacing={2} mb={4}>
                    <Grid item xs={6}>
                        <SelectEmpresa width="100%" size="medium" />
                    </Grid>
                    <Grid
                        item
                        xs={6}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <RadioGroup
                            aria-label="exportar"
                            defaultValue="todos"
                            name="exportar"
                            onChange={e => {
                                setExportarTodos(e.target.value === 'todos')
                            }}
                            row
                        >
                            <FormControlLabel
                                control={<Radio />}
                                label="Exportar todos"
                                value="todos"
                            />
                            <FormControlLabel
                                control={<Radio />}
                                label="Exportar ficha"
                                value="ficha"
                            />
                        </RadioGroup>
                    </Grid>
                    <Grid item xs={12}>
                        {!exportarTodos && <SelectFuncionario width="100%" />}
                    </Grid>
                    <Grid item xs={12}>
                        <FormFieldSelect
                            required
                            label="Formato de exportação"
                            name="formato"
                            fullWidth
                            defaultValue={'xls'}
                            options={[
                                {
                                    value: 'xls',
                                    label: 'Planilha (XLS)',
                                },
                                {
                                    value: 'pdf',
                                    label: 'Documento (PDF)',
                                },
                                {
                                    value: 'csv',
                                    label: 'Texto (CSV)',
                                },
                            ]}
                            onChange={e => {
                                setFormato(e.target.value as typeof formato)
                            }}
                        />
                    </Grid>
                </Grid>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton>
                    Exportar
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}

export default ExportarFuncionario
